import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VendorListPage } from './vendor-list.page';
import { VendorUpdateComponent } from './vendor-update/vendor-update.component';
import { VendorDetailsComponent } from './vendor-details/vendor-details.component';

const routes: Routes = [

  {
    path: '',
    component: VendorListPage
  },
  {
    path: 'update/:id',
    component: VendorUpdateComponent,
    // canActivate: [BaseAppRouteGuardService],
    // data : {
    //   Permission : 'USER_EDIT',
    //   title: "Update User"
    // }
  },
  {
    path: 'details/:id',
    component: VendorDetailsComponent,
    // canActivate: [BaseAppRouteGuardService],
    // data : {
    //   Permission : "USER_DETAILS",
    //   title: "User Details"
    // }
  } 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VendorListRoutingModule {}
